var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"grouped-list__title"},[_c('span',{staticClass:"grouped-list__title-text"},[_vm._t("title")],2),_c('ul',{staticClass:"grouped-list-nested grouped-list"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }